<app-loading *ngIf="!contentReady"></app-loading>

<div class="skills-page container-fluid" dir="rtl" *ngIf="contentReady">
  <div class="page-card">

    <!-- Header -->
    <div class="skills-header">
      <div>
        <h2>إدارة الدول والمدن</h2>
        <p>إضافة وتعديل بيانات الدول والمدن المستخدمة داخل الوظائف</p>
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs-switch">
      <button
        type="button"
        [class.active]="activeTab === 'countries'"
        (click)="setTab('countries')"
      >
        الدول
      </button>

      <button
        type="button"
        [class.active]="activeTab === 'cities'"
        (click)="setTab('cities')"
      >
        المدن
      </button>
    </div>

    <!-- Countries -->
    <ng-container *ngIf="activeTab === 'countries'">

      <form class="skill-form-card" [formGroup]="countryForm" (ngSubmit)="addCountry()">
        <div class="form-grid">

          <div class="form-item">
            <label>اسم الدولة بالإنجليزي</label>
            <input
              type="text"
              formControlName="country_name_en"
              placeholder="Example: Egypt"
              [class.is-invalid]="countryForm.get('country_name_en')?.invalid && countryForm.get('country_name_en')?.touched"
            />
          </div>

          <div class="form-item">
            <label>اسم الدولة بالعربي</label>
            <input
              type="text"
              formControlName="country_name_ar"
              placeholder="مثال: مصر"
              [class.is-invalid]="countryForm.get('country_name_ar')?.invalid && countryForm.get('country_name_ar')?.touched"
            />
          </div>

          <div class="form-actions">
            <button
              type="submit"
              class="main-btn"
              [disabled]="countryForm.invalid || isCountrySubmitting"
            >
              @if(isCountrySubmitting){
                جاري الحفظ...
              }
              @else{
                + إضافة دولة
              }
            </button>
          </div>

        </div>
      </form>

      <div class="skills-table-card">
        <div class="table-head">
          <div>
            <h3>قائمة الدول</h3>
            <p>كل الدول المضافة حاليًا داخل النظام</p>
          </div>
        </div>

        <div class="table-wrapper" *ngIf="countries.length > 0">
          <table class="skills-table country-table">
            <thead>
              <tr>
                <th>#</th>
                <th>الاسم بالإنجليزي</th>
                <th>الاسم بالعربي</th>
                <th>الإجراء</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let country of countries; let i = index">
                <td>{{ i + 1 }}</td>

                <td>
                  <strong>{{ country.country_name_en || '-' }}</strong>
                </td>

                <td>
                  <strong>{{ country.country_name_ar || '-' }}</strong>
                </td>

                <td>
                  <button
                    class="delete-btn"
                    type="button"
                    (click)="deleteCountry(country.id)"
                  >
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="empty-box" *ngIf="countries.length === 0">
          لا توجد دول حاليًا
        </div>
      </div>

    </ng-container>

    <!-- Cities -->
    <ng-container *ngIf="activeTab === 'cities'">

      <form class="skill-form-card" [formGroup]="cityForm" (ngSubmit)="addCity()">
        <div class="form-grid">

          <div class="form-item">
            <label>الدولة</label>
            <select
              formControlName="country_id"
              [class.is-invalid]="cityForm.get('country_id')?.invalid && cityForm.get('country_id')?.touched"
            >
              <option value="">اختر الدولة</option>
              <option *ngFor="let country of countries" [value]="country.id">
                {{ country.country_name_ar || country.country_name_en }}
              </option>
            </select>
          </div>

          <div class="form-item">
            <label>اسم المدينة بالإنجليزي</label>
            <input
              type="text"
              formControlName="city_name_en"
              placeholder="Example: Cairo"
              [class.is-invalid]="cityForm.get('city_name_en')?.invalid && cityForm.get('city_name_en')?.touched"
            />
          </div>

          <div class="form-item">
            <label>اسم المدينة بالعربي</label>
            <input
              type="text"
              formControlName="city_name_ar"
              placeholder="مثال: القاهرة"
              [class.is-invalid]="cityForm.get('city_name_ar')?.invalid && cityForm.get('city_name_ar')?.touched"
            />
          </div>

          <div class="form-actions">
            <button
              type="submit"
              class="main-btn"
              [disabled]="cityForm.invalid || isCitySubmitting"
            >
              @if(isCitySubmitting){
                جاري الحفظ...
              }
              @else{
                + إضافة مدينة
              }
            </button>
          </div>

        </div>
      </form>

      <div class="skills-table-card">
        <div class="table-head">
          <div>
            <h3>قائمة المدن</h3>
            <p>كل المدن المضافة حاليًا داخل النظام</p>
          </div>
        </div>

        <div class="table-wrapper" *ngIf="cities.length > 0">
          <table class="skills-table city-table">
            <thead>
              <tr>
                <th>#</th>
                <th>الدولة</th>
                <th>الاسم بالإنجليزي</th>
                <th>الاسم بالعربي</th>
                <th>الإجراء</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let city of cities; let i = index">
                <td>{{ i + 1 }}</td>

                <td>
                  <span class="category-badge">
                    {{ getCountryName(city.country_id, city.country) }}
                  </span>
                </td>

                <td>
                  <strong>{{ city.city_name_en || '-' }}</strong>
                </td>

                <td>
                  <strong>{{ city.city_name_ar || '-' }}</strong>
                </td>

                <td>
                  <button
                    class="delete-btn"
                    type="button"
                    (click)="deleteCity(city.id)"
                  >
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="empty-box" *ngIf="cities.length === 0">
          لا توجد مدن حاليًا
        </div>
      </div>

    </ng-container>

  </div>
</div>